import { Component } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Environment } from '@aptsi-types';
import { ErrorDialogComponent } from 'src/app/shared/dialogs/error-dialog/error-dialog.component';
import { SuccessDialogComponent } from 'src/app/shared/dialogs/success-dialog/success-dialog.component';
import { EnvironmentService } from '../environment.service';
import { MatDialog } from '@angular/material/dialog';
import { KeycloakStateService } from 'src/app/core/service/utility.service';
import { EnvironmentService as CoreEnvironmentService } from 'src/app/core/service/environment.service';

@Component({
  selector: 'app-environment-create-or-update',
  templateUrl: './environment-create-or-update.component.html',
  styleUrls: ['./environment-create-or-update.component.scss']
})
export class EnvironmentCreateOrUpdateComponent {

  isCreate = false;
  existingEnvironmentId: string = null;
  environment: Environment = null;
  variables: string[] = [];
  filteredVariables: string[] = [];
  organizationId: string;
  form: FormGroup;
 

  // ─────────────────────────────
  // Lifecycle
  // ─────────────────────────────
  constructor(
    private route: ActivatedRoute,
    private environmentService: EnvironmentService,
    private dialog: MatDialog,
    private router: Router,
    private keycloakStateService: KeycloakStateService,
    public coreEnvironmentService: CoreEnvironmentService
  ) {}

  async ngOnInit(): Promise<void> {
    this.organizationId = this.keycloakStateService.getOrganizationId(); // <-- Retrieve here
    console.log("Organization ID in component:", this.organizationId);
    this.isCreate = Boolean(this.route.snapshot.data.create);
    this.existingEnvironmentId = this.route.snapshot.params.environmentId;
    

    if (!this.isCreate) {
      this.fetchEnvironment();
    }

    this.form = this.isCreate
      ? new FormGroup({
          environmentId: new FormControl(null),
          environmentName: new FormControl(null, Validators.required),
          description: new FormControl(null, Validators.required),
         
        })
      : new FormGroup({
          environmentId: new FormControl(this.existingEnvironmentId, Validators.required),
          environmentName: new FormControl(
            this.environment?.environmentName || null,
            Validators.required
          ),
          description: new FormControl(
            this.environment?.description || null,
            Validators.required
          ),
        });
  }

  // ─────────────────────────────
  // Data Fetching
  // ─────────────────────────────
  async fetchEnvironment() {
    try {
      const response = await this.environmentService
        .getEnvironment(this.existingEnvironmentId)
        .toPromise();
      this.environment = response['Resource retrieved successfully']?.[0];

      console.log("Fetched Environment:", this.environment);

      if (this.environment) {
        this.form.patchValue({
          environmentName: this.environment.environmentName,
          description: this.environment.description,
        });
      }
    } catch (error) {
      console.error("Error fetching rules:", error);
    }
  }

  // ─────────────────────────────
  // Validation
  // ─────────────────────────────
  typeValidator(control: AbstractControl): { [key: string]: any } | null {
    return control.value === "None" ? { noneSelected: true } : null;
  }

  // ─────────────────────────────
  // Submit Logic
  // ─────────────────────────────
  async submit() {
    try {
      if (this.isCreate) {
        let res = await this.environmentService
          .createEnvironment(
            this.form.value.environmentName,
            this.form.value.description,
            this.organizationId
          )
          .toPromise();

        
          this.openSuccessDialog(this.isCreate);
       
      } else {
        await this.environmentService
          .updateEnvironment(
            this.form.value.environmentId,
            this.form.value.environmentName,
            this.form.value.description,
            this.organizationId
          )
          .toPromise();

        this.openSuccessDialog(this.isCreate);
      }
    } catch (error) {
      this.openErrorDialog(error.message || "An unexpected error occurred.");
    }
  }

  // ─────────────────────────────
  // Navigation
  // ─────────────────────────────
  cancel() {
    this.router.navigate(["secure-zone/environment/search"]);
  }

  // ─────────────────────────────
  // Dialogs
  // ─────────────────────────────
  openSuccessDialog(isCreate: boolean): void {
    this.dialog
      .open(SuccessDialogComponent, {
        width: "250px",
        data: { isCreate: isCreate, isCreateUpdate: true, title: "Environment" },
      })
      .afterClosed()
      .subscribe(() => {
        this.router.navigate(["secure-zone/environment/search"]);
      });
  }


  openErrorDialog(errorMessage: string): void {
    this.dialog.open(ErrorDialogComponent, {
      width: "250px",
      data: { errorMessage },
    });
  }
}
